import { Input, InputProps } from '@chakra-ui/react';
import { FieldPath, UseFormReturn } from 'react-hook-form';

type PlaneTextInputProps<TFieldValues> = InputProps & {
  name: FieldPath<TFieldValues>;
  register: UseFormReturn<TFieldValues>['register'];
};

export const PlaneTextInput = <TFieldValues,>({
  name,
  register,
  ...inputProps
}: PlaneTextInputProps<TFieldValues>) => (
  <Input
    type="text"
    {...register(name, {
      required: '必須項目です。',
      maxLength: {
        value: 255,
        message: '255文字以内で入力してください',
      },
    })}
    {...inputProps}
  />
);
